import { render } from "./detailaccounthis.vue?vue&type=template&id=1f868b90&scoped=true"
import script from "./detailaccounthis.vue?vue&type=script&lang=js"
export * from "./detailaccounthis.vue?vue&type=script&lang=js"

import "./detailaccounthis.vue?vue&type=style&index=0&id=1f868b90&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f868b90"]])

export default __exports__